import { render, staticRenderFns } from "./CreateCustomerUserPopUp.vue?vue&type=template&id=bd3b9008&scoped=true&"
import script from "./CreateCustomerUserPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerUserPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerUserPopUp.vue?vue&type=style&index=0&id=bd3b9008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3b9008",
  null
  
)

export default component.exports